// common
export const RESET_STATE = 'resetAll'

// --
export const SET_ALL_FIRMS = 'setAll'
export const SET_FIRM = 'set'
export const RESET_FIRM = 'reset'
export const ADD_OR_REPLACE_FIRM = 'addOrReplaceFirm'
export const REMOVE_FIRM = 'removeFirm'
